/**
 * Building cluster.
 *
 * @todo @export
 *
 * @interface BuildingCluster
 */
interface BuildingCluster {

  /** Cluster id. */
  _id: string;

  /** Active state. */
  active: boolean;

  /** Collection of areas. */
  areas: Area[];

  /** Creation date as ISO string. */
  created: string;

  /** Cluster name. */
  name: string;

  /** Cluster shortcode. */
  shortCode: string;

  /** Last updated as ISO string. */
  updated: string;
};
